import { en } from './en';
import { ar } from './ar';
import { ku } from './ku';

export const translations = { en, ar, ku };
